var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f28a4",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.6094 12.948c-0.52067 0.5207-0.52067 1.3649 0 1.8856l6.523 6.5165c1.0415 1.0406 2.7292 1.0402 3.7703-8e-4l6.5205-6.5205c0.5207-0.5207 0.5207-1.3649 0-1.8856s-1.365-0.5207-1.8857 0l-5.5808 5.5808c-0.5207 0.5208-1.365 0.5208-1.8856 0l-5.5762-5.576c-0.52067-0.5207-1.3648-0.5207-1.8856 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon_arrow-down.91f6c96e9ad54824f954c20bade74ec1.svg";
export { ForwardRef as ReactComponent };